// src/components/common/FeaturesSection.js

import React from 'react';
import './featureSection.css';

function FeaturesSection({ features }) {
  return (
    <section className="features-section">
      <h2 className="features-title">Built for Self Learners</h2>
      <div className="features-container">
        {features.map((feature, index) => (
          <div key={index} className="feature-card">
            {/* ✅ Render icon using <img /> instead of class-based div */}
            <img src={feature.iconSrc} alt={feature.title} className="feature-icon" />
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FeaturesSection;
